import { render } from "./Login-main.vue?vue&type=template&id=f7be332e&scoped=true&lang=pug"
import script from "./Login-main.vue?vue&type=script&lang=js"
export * from "./Login-main.vue?vue&type=script&lang=js"

import "./Login-main.vue?vue&type=style&index=0&id=f7be332e&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7be332e"]])

export default __exports__